import { useEffect, useState } from "react";
import { parseCssColorToHex, buildCtaCssProps, sampleImageAverageHex } from "../utils/ctaAccentFromBrand";

/**
 * Sets CSS variables for .begin-play-btn--themed from userData theme colors,
 * else samples the logo only (not full-screen bg — that skews buttons purple/muddy).
 * @param {object | null} userData
 * @param {string} [logoSrc] — URL shown in UI (company logo or bundled)
 */
export function useBrandCtaVars(userData, logoSrc) {
  const [style, setStyle] = useState({});
  const [themed, setThemed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const apply = (props) => {
      if (cancelled) return;
      if (props && Object.keys(props).length > 0) {
        setStyle(props);
        setThemed(true);
      } else {
        setStyle({});
        setThemed(false);
      }
    };

    if (!userData) {
      apply(null);
      return () => {
        cancelled = true;
      };
    }

    const btnHex = parseCssColorToHex(userData.button_color);
    const titleHex = parseCssColorToHex(userData.landing_page_title_color);
    const textHex = parseCssColorToHex(
      userData.button_text_color || userData.button_Textcolor
    );

    if (btnHex || titleHex) {
      apply(buildCtaCssProps(btnHex || titleHex, { textHex }));
      return () => {
        cancelled = true;
      };
    }

    const logo = logoSrc && String(logoSrc).trim() ? String(logoSrc).trim() : "";

    if (logo) {
      sampleImageAverageHex(logo, (hexLogo) => {
        if (cancelled) return;
        if (hexLogo) apply(buildCtaCssProps(hexLogo, { textHex }));
        else apply(null);
      });
    } else {
      apply(null);
    }

    return () => {
      cancelled = true;
    };
  }, [userData, logoSrc]);

  return { style, themed };
}
